import { useSelector } from "react-redux";

export default function useGetArticulosByGrupo(grupo) {
  const {articulos} = useSelector((state) => state.articulosReducer);
  const articulosGrupo = articulos.filter((a) => a.grupo === grupo);
  return { articulosGrupo };
}
